import getToken from '@utility/getToken';
import Logger from '@utility/services/Logger';
import TetraController from '@utility/TetraController';
import React, { useState } from 'react';
import { Button, Input } from '@heroui/react';

export const AiJobDescription = (props) => {
  const { setJobData } = props;
  const [aiJobTitle, setAiJobTitle] = useState('');
  const [generatingJobDescription, setGeneratingJobDescription] =
    useState(false);

  const generateJobDescription = async () => {
    if (!aiJobTitle) {
      return;
    }
    setGeneratingJobDescription(true);
    try {
      const token = await getToken();
      const response = await TetraController.generateJobDescripton(token, {
        jobTitle: aiJobTitle,
      });
      setJobData({
        jobTitle: response?.job_title ?? '',
        location: response?.location ?? '',
        completeJobDescription: response?.complete_job_description ?? '',
        company: response?.company ?? '',
      });
    } catch (err) {
      Logger.LogError(err);
    } finally {
      setGeneratingJobDescription(false);
    }
  };
  return (
    <div className="grid gap-[8px] grid-cols-4">
      <Input
        className="col-span-3"
        size="md"
        variant="bordered"
        label="Generate a sample job description using AI:"
        placeholder="Add Job Title"
        labelPlacement="outside"
        defaultValue="software engineer"
        value={aiJobTitle}
        onChange={(e) => setAiJobTitle(e.target.value)}
      />
      <Button
        size="md"
        className=" self-end"
        color="primary"
        radius="full"
        onClick={aiJobTitle ? generateJobDescription : {}}
        isDisabled={!aiJobTitle}
        isLoading={generatingJobDescription}
      >
        {generatingJobDescription ? 'Generating' : 'Generate'}
      </Button>
    </div>
  );
};
